// extracted by mini-css-extract-plugin
module.exports = {"detail":"DetailCard_detail__ZM-1M","header":"DetailCard_header__fXOVC","headerLabel":"DetailCard_headerLabel__14KC7","secondaryText":"DetailCard_secondaryText__A5xFL"};